import { render, staticRenderFns } from "./PlusMinusButton.vue?vue&type=template&id=6f0de916&scoped=true&"
import script from "./PlusMinusButton.vue?vue&type=script&lang=js&"
export * from "./PlusMinusButton.vue?vue&type=script&lang=js&"
import style0 from "./PlusMinusButton.vue?vue&type=style&index=0&id=6f0de916&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0de916",
  null
  
)


    import installComponents from "!/Users/jurajpetras/dev/pmat/web/frontend-internal/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BLink} from 'bootstrap-vue'
    installComponents(component, {BLink})
    


    import installDirectives from "!/Users/jurajpetras/dev/pmat/web/frontend-internal/node_modules/bootstrap-vue-loader/lib/runtime/installDirectives.js"
    import {VBPopover} from 'bootstrap-vue'
    installDirectives(component, {'b-popover': VBPopover})
    

export default component.exports